export default __webpack_public_path__ + "static/media/school.fc70366c.svg";